<template>
	<main-container>
		<material-card icon="fas fa-laptop-house" :title="$t('tenant.table_title')" class="mb-10">
			<div slot="after-heading" v-if="user.tenant" class="font-weight-bold">
				{{ user.tenant.fullname }}
			</div>
			<v-row dense>
				<v-col cols="12" xs="12" sm="4">
					<list-content-value boldtitle :contenttitle="$t('tenant.taxcode')" :contentvalue="is_userloading ? null : user.tenant.taxcode" :loading="is_userloading"></list-content-value>
					<list-content-value boldtitle :contenttitle="$t('tenant.vatid')" :contentvalue="is_userloading ? null : user.tenant.vatid" :loading="is_userloading"></list-content-value>
					<list-content-value boldtitle :contenttitle="$t('tenant.ateco')" :contentvalue="is_userloading ? null : user.tenant.ateco" :loading="is_userloading"></list-content-value>
					<list-content-value icon="fas fa-map-marker-alt" action @click="$functions.openLink($formatters.formatAddress(user.tenant), 'map')" boldtitle :contenttitle="$t('tenant.address')" :contentvalue="is_userloading ? null : $formatters.formatAddress(user.tenant)" :loading="is_userloading"></list-content-value>
				</v-col>
				<v-col cols="12" xs="12" sm="4">
					<list-content-value icon="fas fa-phone-alt" action @click="$functions.openLink(user.tenant.phone, 'phone')" boldtitle :contenttitle="$t('tenant.phone')" :contentvalue="is_userloading ? null : user.tenant.phone" :loading="is_userloading"></list-content-value>
					<list-content-value icon="fab fa-whatsapp" action @click="$functions.openLink(user.tenant.whatsapp, 'whatsapp')" boldtitle :contenttitle="$t('tenant.whatsapp')" :contentvalue="is_userloading ? null : user.tenant.whatsapp" :loading="is_userloading"></list-content-value>
					<list-content-value icon="fas fa-envelope" action @click="$functions.openLink(user.tenant.email, 'email')" boldtitle :contenttitle="$t('tenant.email')" :contentvalue="is_userloading ? null : user.tenant.email" :loading="is_userloading"></list-content-value>
					<list-content-value icon="fas fa-globe-africa" action @click="$functions.openLink(user.tenant.website)" boldtitle :contenttitle="$t('tenant.website')" :contentvalue="is_userloading ? null : user.tenant.website" :loading="is_userloading"></list-content-value>
				</v-col>
				<v-col cols="12" xs="12" sm="4">
					<v-hover v-slot:default="{ hover }" v-if="$appOptions.tenantLogo() != null">
						<v-img :src="$appOptions.tenantLogo()" contain @click="upload_logo = true" max-height="200" class="clickarea">
							<template v-slot:placeholder>
								<v-sheet>
									<v-skeleton-loader type="image"></v-skeleton-loader>
								</v-sheet>
							</template>
							<v-expand-transition>
								<div v-if="hover" class="clickarea d-flex transition-fast-in-fast-out hoverblack" style="height: 100%; width: 100%; justify-content: center; background-color: rgba(68, 68, 68, 0.5)" @click="upload_logo = true">
									<v-icon dark large>fas fa-camera</v-icon>
								</div>
							</v-expand-transition>
						</v-img>
					</v-hover>
					<v-card outlined @click="upload_logo = true" v-else class="mt-0">
						<v-card-text>
							<v-row class="d-flex flex-column" dense align="center" justify="center">
								<v-icon class="mt-5" size="60">fas fa-camera</v-icon>
								<p>{{ $t("tenant.click_to_upload") }}</p>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<template slot="actions">
				<v-col cols="6" xs="6" sm="3">
					<action-button large @click="editTenantData()" color="warning" :text="$t('global.edit')"></action-button>
				</v-col>
			</template>
		</material-card>
		<instant-edit v-model="upload_logo" icon="fas fa-camera" :title="$t('tenant.upload_logo')">
			<div slot="afterheading">Seleziona l'immagine da utilizzare come logo</div>
			<v-row dense>
				<v-col cols="12" xs="12">
					<upload-file :types="['image']" @fileuploaded="uploadTenantLogo" :uploading="tenantlogo_loading"></upload-file>
				</v-col>
			</v-row>
		</instant-edit>
		<edit-tenant v-if="showEditTenant"></edit-tenant>
	</main-container>
</template>

<script>
export default {
	data: () => ({
		upload_logo: false,
		formData: null,
	}),
	computed: {
		showEditTenant() {
			return this.$store.getters.showEditTenant;
		},
		user() {
			return this.$store.getters.getUser;
		},
		is_userloading() {
			return this.$store.getters.is_userloading;
		},
		tenantlogo_loading() {
			return this.$store.getters.tenantlogo_loading;
		},
		tenantinfo_loading() {
			return this.$store.getters.tenantinfo_loading;
		},
		tenantinfo() {
			return this.$store.getters.getTenantInfo;
		},
	},
	methods: {
		uploadTenantLogo(files) {
			this.formData = new FormData();
			this.formData.append("logo", files[0]);
			this.$store.dispatch("uploadTenantLogo", this.formData).then((res) => {
				if (res.code == 0) {
					this.upload_logo = false;
					this.formData = null;
				}
			});
		},
		editTenantData() {
			this.$store.commit("setTemporaryTenant", _.cloneDeep(this.user.tenant));
			this.$store.dispatch("showAction", "showEditTenant");
		},
	},
	created() {
		this.$store.dispatch("fetchTenantInfo");
	},
};
</script>
